import LogoSvg from '@/app/_assets/logos/logo.svg';

export function FormEmbedAdditionalContent() {
  return (
    <div className="h-8">
      <LogoSvg className="h-full w-auto text-white" />
    </div>
  );
}
